<template>
  <ResearchGalleryPage
    :page-title="pageTitle"
    section-label="领导关怀"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="visibleGroups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';
import { LEADERSHIP_CHAPTERS } from '@/config/secondarySidebar';

export default {
  name: 'LanhuXuenihongzhao',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          id: 'approval-document',
          title: '批复文件影印件',
          kicker: '1978',
          columns: 1,
          items: [
            {
              src: require('./assets/html/leadership-1978-document.jpg'),
              caption: '1978 年 6 月 15 日，邓小平、李先念等党和国家领导人批复同意中国社会科学院增设新闻研究所的文件影印件'
            }
          ]
        },
        {
          id: 'beijing-journalism-association',
          chapterId: 'beijing-journalism-association',
          title: '北京新闻学会成立大会',
          kicker: '1980',
          columns: 1,
          items: [
            {
              src: require('./assets/html/leadership-1980-meeting.jpg'),
              caption: '1980 年 2 月 6 日，北京新闻学会（挂靠在新闻研究所，1984 年改名为首都新闻学会）成立大会在中国革命历史博物馆礼堂召开。胡乔木到会讲话，胡愈之、张友渔等出席会议，安岗主持会议'
            }
          ]
        },
        {
          id: 'meeting-leaders',
          chapterId: 'beijing-journalism-association',
          title: '出席会议领导',
          kicker: '1980',
          columns: 4,
          items: [
            {
              src: require('./assets/html/leadership-1980-hu-qiaomu.jpg'),
              caption: '胡乔木'
            },
            {
              src: require('./assets/html/leadership-1980-hu-yuzhi.jpg'),
              caption: '胡愈之'
            },
            {
              src: require('./assets/html/leadership-1980-zhang-youyu.jpg'),
              caption: '张友渔'
            },
            {
              src: require('./assets/html/leadership-1980-an-gang.jpg'),
              caption: '安岗（前右二）'
            }
          ]
        },
        {
          id: 'three-s-association',
          chapterId: 'three-s-association',
          title: '“三 S”研究会成立大会',
          kicker: '1984',
          columns: 2,
          items: [
            {
              src: require('./assets/layout-6_1.png'),
              caption: '1984 年 9 月 20 日，新闻研究所牵头组织的“中国史沫特莱、斯特朗、斯诺（简称‘三 S’）研究会”成立大会在人民大会堂召开。邓颖超、黄华等出席会议并先后致辞，安岗出席会议'
            },
            {
              src: require('./assets/layout-6_2.png'),
              caption: '名誉会长邓颖超致辞'
            }
          ]
        },
        {
          id: 'meeting-speeches',
          chapterId: 'three-s-association',
          title: '会议发言与现场',
          kicker: '1984',
          columns: 5,
          items: [
            {
              src: require('./assets/layout-6_3.png'),
              caption: '会长黄华致辞'
            },
            {
              src: require('./assets/layout-6_4.png'),
              caption: '路易·艾黎致辞'
            },
            {
              src: require('./assets/layout-6_5.png'),
              caption: '爱泼斯坦致辞'
            },
            {
              src: require('./assets/layout-6_6.png'),
              caption: '所长安岗致辞'
            },
            {
              src: require('./assets/layout-6_7.png'),
              caption: '副所长东生向康克清介绍情况'
            }
          ]
        },
        {
          id: 'academy-leadership',
          title: '院领导到所会议与合影',
          kicker: '2008-2018',
          columns: 2,
          items: [
            {
              src: require('./assets/layout-7_1.png'),
              caption: '2008 年 9 月，全国政协副主席，中国社会科学院院长、党组书记陈奎元到新闻与传播研究所调研指导，并祝贺中国社会科学院研究生院新闻学与传播学系成立三十周年。右上图为中国社会科学院秘书长黄浩涛等陪同陈奎元院长调研'
            },
            {
              src: require('./assets/layout-7_2.png'),
              caption: '2008 年 9 月，陈奎元院长在新闻与传播研究所参观古籍资料'
            },
            {
              src: require('./assets/layout-8_1.png'),
              caption: '2018 年 11 月，中国社会科学院院长、党组书记谢伏瞻同新闻与传播研究所领导班子成员合影'
            },
            {
              src: require('./assets/layout-8_2.png'),
              caption: '2014 年 5 月，中国社会科学院党组会议在新闻与传播研究所会议室召开。其间，中国社会科学院院长、党组书记王伟光等院领导同新闻与传播研究所党委委员合影'
            }
          ]
        },
        {
          id: 'academic-platform',
          title: '学术平台与调研指导',
          kicker: '2006-2018',
          columns: 3,
          items: [
            {
              src: require('./assets/layout-9_2.png'),
              caption: '2006 年 4 月，新闻与传播研究所和河北大学举办的中国传播学会成立大会暨第九次全国传播学研讨会在河北省保定市举行。中国社会科学院常务副院长冷溶出席开幕式并致辞'
            },
            {
              src: require('./assets/layout-9_3.png'),
              caption: '2016 年 6 月，中国社会科学院副院长、党组副书记王京清到新闻与传播研究所调研指导工作'
            },
            {
              src: require('./assets/layout-9_1.png'),
              caption: '2018 年 1 月，新闻与传播研究所与上海大学共建的上海研究院世界传媒研究中心成立。中国社会科学院副院长李培林出席揭牌仪式'
            }
          ]
        },
        {
          id: 'conference-forum-inspection',
          title: '发布会、论坛与纪检调研',
          kicker: '2010-2018',
          columns: 3,
          items: [
            {
              src: require('./assets/layout-10_1.png'),
              caption: '2010 年 7 月，新闻与传播研究所与社会科学文献出版社联合主办《中国新媒体发展报告》发布会。中国社会科学院副院长李慎明出席会议并致辞'
            },
            {
              src: require('./assets/layout-10_2.png'),
              caption: '2014 年 9 月，新闻与传播研究所承办的中国社会科学论坛“性别与传播：信息传播技术的使用、再现、发声与赋权”暨第五届中国 - 北欧妇女与性别研讨会在北京举行。中国社会科学院副院长蔡昉、中国妇女研究会副会长李秋芳出席开幕式并致辞'
            },
            {
              src: require('./assets/layout-10_3.png'),
              caption: '2018 年 1 月，中央纪委驻中国社会科学院纪检监察组组长邓中华到新闻与传播研究所调研指导工作'
            }
          ]
        },
        {
          id: 'cooperation-platform-research',
          title: '共建平台与宣传思想文化战线调研',
          kicker: '2014-2018',
          columns: 3,
          items: [
            {
              src: require('./assets/layout-11_3.png'),
              caption: '2014 年 10 月，中国新闻文化促进会传播学分会和新闻与传播研究所共同主办的第十二届中国传播学大会在北京举行。全国政协委员、中国新闻文化促进会会长李东东，中国社会科学院秘书长高翔出席开幕式并致辞'
            },
            {
              src: require('./assets/layout-11_1.png'),
              caption: '2015 年 11 月，中国社会科学院新媒体研究中心成立。中国社会科学院秘书长高翔出席中心揭牌仪式'
            },
            {
              src: require('./assets/layout-11_2.png'),
              caption: '2018 年 3 月，中国社会科学院党组成员张英伟率新闻与传播研究所调研组一行赴河北日报报业集团进行宣传思想文化战线大调研'
            }
          ]
        }
      ]
    };
  },
  computed: {
    activeChapterId() {
      const routeQuery = this.$route && this.$route.query ? this.$route.query : {};
      const requestedChapter = routeQuery.chapter || routeQuery.subitem;
      const fallbackChapter = LEADERSHIP_CHAPTERS[0].id;
      return LEADERSHIP_CHAPTERS.some((chapter) => chapter.id === requestedChapter) ? requestedChapter : fallbackChapter;
    },
    currentGroup() {
      return this.visibleGroups[0] || this.groups[0];
    },
    pageTitle() {
      return this.currentGroup ? this.currentGroup.title : '珍贵历史图片资料';
    },
    sectionRoute() {
      return {
        path: '/lanhu_jigouyulishi',
        query: {
          item: 'leadership-care',
          subitem: this.activeChapterId
        }
      };
    },
    visibleGroups() {
      return this.groups.filter((group) => (group.chapterId || group.id) === this.activeChapterId);
    }
  }
};
</script>
